import * as RequestState from './RequestState';
import { RequestStateValue } from './RequestStateTypes';

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isUninitialized = (requestState: RequestStateValue) => {
  return requestState === RequestState.UNINITIALIZED;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isPending = (requestState: RequestStateValue) => {
  return requestState === RequestState.PENDING;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isFulfilled = (requestState: RequestStateValue) => {
  return (
    requestState === RequestState.SUCCEEDED ||
    requestState === RequestState.FAILED
  );
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isSucceeded = (requestState: RequestStateValue) => {
  return requestState === RequestState.SUCCEEDED;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isFailed = (requestState: RequestStateValue) => {
  return requestState === RequestState.FAILED;
};
